<template>
    <div class="container" :style="{marginTop: '20px'}">
        <div class="box-title">
            <h4>
                <i class="fal fa-gifts"></i>
                ລາຍການທັງໝົດ
                <span class="countTotal">({{totalOrder}})</span>
            </h4>
            <span>
                <div class="filed">
                    <div class="control">
                        <input class="input" placeholder="ຄົ້ນຫາ ລະຫັດລາຍການ..." v-model="searchOrderId">
                    </div>
                </div>
            </span>
        </div><br>

        <div class="center">
            <vs-table>
                <template #thead>
                    <vs-tr>
                        <vs-th>ລຳດັບ</vs-th>
                        <vs-th>ລະຫັດ ລາຍການ</vs-th>
                        <vs-th>ປະເພດພາຫະນະ</vs-th>
                        <vs-th>ຊື່ລູກຄ້າ</vs-th>
                        <vs-th>ປະເພດພັດສະດຸ</vs-th>
                        <vs-th>ຈຳນວນ</vs-th>
                        <vs-th>ນ້ຳໜັກ</vs-th>
                        <vs-th>ວັນທີ່ສ້າງລາຍການ</vs-th>
                        <vs-th>ເວລານັດຮັບເຄື່ອງ</vs-th>
                        <vs-th>ຜູ້ຮັບຜິດຊອບ</vs-th>
                        <vs-th>ສະຖານະ</vs-th>
                        <vs-th></vs-th>
                    </vs-tr>
                </template>
                <template #tbody>
                    <vs-tr
                        :key="index" :data="orderPending"
                        v-for="(orderPending, index) in FilterOrderRequestPending"
                    >
                        <vs-td>{{ index + 1 }}</vs-td>
                        <vs-td :style="{width: '15%', color: 'crimson'}">
                            ( {{orderPending.order_id}} )
                        </vs-td>
                        <vs-td>
                            <span v-if="orderPending.vehicle_type == 'motorcycle'">ລົດຈັກ</span>
                            <span v-if="orderPending.vehicle_type == 'car'">ລົດໃຫຍ່</span>
                        </vs-td>
                        <vs-td>{{orderPending.customer_name}}</vs-td>
                        <vs-td>{{orderPending.categ_name}}</vs-td>
                        <vs-td>{{orderPending.amount}}</vs-td>
                        <vs-td>{{orderPending.weight}} kg</vs-td>
                        <vs-td>{{FormatDate(orderPending.created_at)}}</vs-td>
                        <vs-td>
                            {{FormatDateSchedule(orderPending.schedule)}}
                            <span>
                                - {{orderPending.schedule_time !== null ? orderPending.schedule_time : '..............'}}
                            </span>
                        </vs-td>
                        <vs-td>
                            <span :style="{color: '#195BFF'}">
                                ( {{orderPending.rider_name !== null ? orderPending.rider_name : '.................'}} )
                            </span>
                        </vs-td>
                        <vs-td>
                            <span v-if="orderPending.status == 'pending'" :style="{color: '#F57920'}">ລໍຖ້າອະນຸມັດ</span>
                            <span v-if="orderPending.status == 'confirm'" :style="{color: '#195BFF'}">ອະນຸມັດເເລ້ວ</span>
                            <span v-if="orderPending.status == 'on_the_way'" :style="{color: 'green'}">ກຳລັງໄປຮັບເຄື່ອງ</span>
                        </vs-td>
                        <vs-td style="text-align: right; width: 100px">
                            <div class="group-icon">
                                <vs-button circle icon flat @click="OpenModalUpdateOrderRequest(orderPending.id)">
                                    <i class="fal fa-pencil-alt"></i>
                                </vs-button>
                                <vs-button circle icon flat @click="OpenModalViewOrderRequestProcessing(orderPending.id)">
                                    <i class="fad fa-eye"></i>
                                </vs-button>
                                <vs-button circle danger icon flat @click="OpenModal_RejectOrderRequest(orderPending.id)">
                                    <i class="fal fa-times-circle"></i>
                                </vs-button>
                            </div>
                        </vs-td>  
                    </vs-tr>
                </template>
                <template #footer>
                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="offset" @paginate="FetchPendingOrderRequest()"></pagination>
                    <Loading v-if="isLoading"/>
                </template>
            </vs-table>
        </div>

        <ModalDelete>
            <template v-slot="{ close }">
                <RejectOrderRequest @close="close" :orderRequestId="orderRequestId" @success="FetchPendingOrderRequest()"/>
            </template>
        </ModalDelete>
        <ModalEdit>
            <template v-slot="{ close }">
                <UpdateOrderRequest @close="close" :orderRequestId="orderRequestId" @success="FetchPendingOrderRequest()"/>
            </template>
        </ModalEdit>

        <ModalPreviewFile>
            <template v-slot="{ close }">
                <PreviewOrderRequest @close="close" :OrderRequest="filterOrderRequest" @success="FetchPendingOrderRequest()"/>
            </template>
        </ModalPreviewFile>

    </div>
</template>

<script>
import mixinsPendingOrderRequests from '@coms/../../src/Mixins/Order-Requests/PendingOrder';
import Loading from '../Loading';
import RejectOrderRequest from './Dialog/Reject';
import PreviewOrderRequest from './Dialog/View-Order';
import UpdateOrderRequest from './Dialog/Update-Order';
import moment from 'moment';
import pagination from '../../Plugins/Paginations/Pagination';

export default {
    components:{
        Loading,
        RejectOrderRequest,
        PreviewOrderRequest,
        UpdateOrderRequest,
        pagination
    },
    methods:{
        FormatDate(value){
            if (value) {
                return moment(String(value)).format('DD/MM/YYYY - HH:mm:ss')
            }
        },
        FormatDateSchedule(date){
            if (date) {
                return moment(String(date)).format('DD/MM/YYYY')
            }
        },
        FormatStartDateAndEndDate(date){
            if (date) {
                return moment(String(date)).format('YYYY-MM-DD')
            }
        }
    },
    mixins:[mixinsPendingOrderRequests],

    created(){
        this.FetchPendingOrderRequest();
    }
}
</script>

<style>

</style>